import {AxiosError} from "axios";
import {BridgeHelper} from "./bridgeHelper";
import {RouteName} from "../common/routeName";
import {GlobalConfig} from "../common/appConfig";

const HttpErrorTool = {
    processError: (error: AxiosError) => {
        if (!error) {return;}
        if (!error.response) {return;}

        let {config, status, statusText, data} = error.response;

        let mError = {
            code: status,
            message: statusText,
            stack: data
        };
        let mErrorInfo = {
            code: status,
            api: config.url,
            param: config.data,
            error: mError
        };

        if (GlobalConfig.isDebug === true) {
            BridgeHelper.modalPage(RouteName.errorPreview, 'Error Preview', {errInfo: mErrorInfo});
        } else {
            BridgeHelper.showToast(statusText)
        }

        return mErrorInfo;
    }
}

export {
    HttpErrorTool
}
